import { MidSectionCard } from "./mid-section-card";
import { MidSectionCardText } from "./mid-section-card-text";
import { MidSectionRow } from "./mid-section-row";
import data_pic from "../assets/images/data_pic.png";
import { RadialGrowBackGround } from "./radial-grow-back-ground";
import { MidSectionContainer } from "../mid-section-contaier";






function MidSection() {
    return (
        <MidSectionContainer>
            {Array.from({ length: 3 }).map((_, i) => (
                <RadialGrowBackGround
                    key={i}
                    animeDelay={`${Math.random() * 5}s`}
                    animeDuration={`${3 + Math.random() * 6}s`}
                    topPosition={`${30 + Math.random() * 40}%`}
                    leftPosition={`${30 + Math.random() * 40}%`}
                />
            ))}
            <MidSectionRow>
                <MidSectionCardText>
                    Our AI-powered tool delivers precise and <br />
                    reliable insights every time, designed to fully <br />
                    to empowers your team with accurate <br />
                    analytics you can trust
                </MidSectionCardText>
                <MidSectionCard>
                    <img style={{ height: "100%", width: "100%" }} src={data_pic} alt="" />
                </MidSectionCard>
            </MidSectionRow >
        </MidSectionContainer>
    );
}


export default MidSection;